import React from 'react';
import '../css/Section.css';

function SpecsSection() {
  const specs = [
    { label: 'Aevolt Everflow Nano Cube', value: 'Compact portable power for phones, lights, laptops, and small essentials during travel or outages. 150W Power, modified sine wave high frequency transformer inverter, lightweight design, 216Wh Capacity. ' },
    { label: 'Aevolt Everflow Nano', value: 'Entry level solar backup system for keeping basic home devices powered when the grid goes down. 250W Power, pure sine wave low frequency transformer inverter, High surge up to 3 seconds, Suitable for induction motor fans and refrigerators, Available in (360Wh/624Wh) Capacity. ' },
    { label: 'Aevolt Everflow Micro', value: 'Mid capacity home backup option for general appliances, and everyday solar support. 500W Power, pure sine wave low frequency transformer inverter, Available in (576Wh/1.2kWh/2.4kWh) Capacity. ' },
    { label: 'Aevolt Everflow Micro-H', value: 'Mid capacity home backup option for general appliances, and everyday solar support. 500W Power, pure sine wave High frequency transformer inverter, Available in (432Wh/624Wh/1.2kWh) Capacity. ' },
    { label: 'Aevolt Everflow Mini', value: 'Higher capacity home backup option for more appliances, longer runtime with 800W high frequency transformer inverter, 1.2 kWh Capacity.' },
    { label: 'Aevolt Hybrid Systems', value: '1kW - 6kW (NEXT, SRNE, Anern, Deye) Hybrid systems with Aevolt batteries and dust proof casing.' }
  ];

  return (
    <section id="specs" className="section dark-section">
      <div className="section-center">
        <p className="eyebrow">Aevolt Everflow</p>
        <h2>Aevolt Everflow Specs</h2>
        <div className="specs-grid">
          {specs.map((spec, index) => (
            <div className="spec-card" key={index}>
              <h4>{spec.label}</h4>
              <p>{spec.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default SpecsSection;
